/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Summary information for a tool call
 */
export type ToolCallSummary = {
  /**
   * Event source (from attributes.gram.event.source)
   */
  eventSource?: string | undefined;
  /**
   * Speakeasy URN associated with this tool call
   */
  gramUrn: string;
  /**
   * HTTP status code (if applicable)
   */
  httpStatusCode?: number | undefined;
  /**
   * Total number of logs in this tool call
   */
  logCount: number;
  /**
   * Earliest log timestamp in Unix nanoseconds (string for JS int64 precision)
   */
  startTimeUnixNano: string;
  /**
   * Tool name (from attributes.gram.tool.name)
   */
  toolName?: string | undefined;
  /**
   * Tool call source (from attributes.gram.tool_call.source)
   */
  toolSource?: string | undefined;
  /**
   * Trace ID (32 hex characters)
   */
  traceId: string;
};

/** @internal */
export const ToolCallSummary$inboundSchema: z.ZodMiniType<
  ToolCallSummary,
  unknown
> = z.pipe(
  z.object({
    event_source: z.optional(z.string()),
    gram_urn: z.string(),
    http_status_code: z.optional(z.int()),
    log_count: z.int(),
    start_time_unix_nano: z.string(),
    tool_name: z.optional(z.string()),
    tool_source: z.optional(z.string()),
    trace_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "event_source": "eventSource",
      "gram_urn": "gramUrn",
      "http_status_code": "httpStatusCode",
      "log_count": "logCount",
      "start_time_unix_nano": "startTimeUnixNano",
      "tool_name": "toolName",
      "tool_source": "toolSource",
      "trace_id": "traceId",
    });
  }),
);

export function toolCallSummaryFromJSON(
  jsonString: string,
): SafeParseResult<ToolCallSummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolCallSummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolCallSummary' from JSON`,
  );
}
